import { uniqBy } from 'lodash-es'
import { type BulkListVehicle } from 'src/utils/scooterBulk/types'

export function addBulkVehicles(bulkList: BulkListVehicle[], vehicles: BulkListVehicle[]) {
    return uniqBy([...bulkList, ...vehicles], v => v.id)
}

export function removeBulkVehicles(bulkList: BulkListVehicle[], vehicles: BulkListVehicle[]) {
    return bulkList.filter(b => !vehicles.some(v => v.id === b.id))
}

export function isVehicleSelected(vehicle: BulkListVehicle, bulkList: BulkListVehicle[]) {
    return bulkList.some(v => v.id === vehicle.id)
}
